import { Box, Dialog, Flex, Heading, IconButton, Link, Text } from '@radix-ui/themes'
import { Cross1Icon } from '@radix-ui/react-icons'
import { PamDocumentContent } from '@Generated/back-office-client/src'

export type PamVerificationDocumentPreviewProps = {
  open: boolean
  fileName: string | null
  content: PamDocumentContent | null
  isLoading: boolean
  onClose: () => void
}

// Inline-renderable data URI (base64 payload) for the <img>/<object> preview and download link.
const toBase64DataUrl = (content: PamDocumentContent): string =>
  `data:${content.contentType};base64,${content.base64}`

export const PamVerificationDocumentPreview = ({
  open,
  fileName,
  content,
  isLoading,
  onClose,
}: PamVerificationDocumentPreviewProps) => {
  const dataUrl = content ? toBase64DataUrl(content) : null

  let body = <Text color="gray">Loading…</Text>
  if (!isLoading && content && dataUrl) {
    if (content.contentType === 'application/pdf') {
      body = (
        <object
          data={dataUrl}
          type="application/pdf"
          width="100%"
          height="600px"
          aria-label={content.fileName}
        />
      )
    } else {
      body = <img src={dataUrl} alt={content.fileName} style={{ maxWidth: '100%' }} />
    }
  }

  return (
    <Dialog.Root open={open} onOpenChange={(next) => (next ? undefined : onClose())}>
      <Dialog.Content style={{ maxWidth: 720 }}>
        <Flex align="center" justify="between" mb="3">
          <Heading size="4">{fileName ?? 'Document Preview'}</Heading>
          <IconButton variant="ghost" aria-label="Close preview" onClick={onClose}>
            <Cross1Icon />
          </IconButton>
        </Flex>
        <Box>{body}</Box>
        {dataUrl && (
          <Box mt="3">
            <Link href={dataUrl} download={content?.fileName}>
              Download
            </Link>
          </Box>
        )}
      </Dialog.Content>
    </Dialog.Root>
  )
}
